<template>
  <div class="mobile" v-empty="empty" :empty-text="emptyText" @scroll="handleScroll" ref="scroll">
    <search :inputValue="value" :showCollect="showCollect"></search>
    <div class="group-wrapper">
      <group-swiper :data="groups" :index="selectGroup" :isMobile="true"></group-swiper>
      <div class="s-suggest" @click="showModal" v-if="suggest">
          <span class="sound"></span>
          <span class="text">{{ suggesText }}</span>
          <span class="close" @click.stop="()=>suggest = false"></span>
      </div>
    </div>
    <imgList :data="data" :search="value" :isHistory="isHistory" v-if="show" :style="{'margin-top': data.length > 0 ? (suggest ? '142px' : '100px' ) : '0'}" />
    <div class="page-footer" :style="{paddingBottom: isFullScreen ? '34px' : '.07rem'}" v-if="homeFinish && data.length > 0">
      <hxm-footer type="text" :content="$t('2b496a8eac')"></hxm-footer>
    </div>
  </div>
</template>
<script>
import imgList from '@/components/mobile/mImgList'
import groupSwiper from '@/components/groupSwiper'
import {getList, getTypeList} from '@/api/apiList'
import search from '@/components/mobile/mSearch'
import {throttle, uniqueArr} from '@/common'
export default {
  data() {
    return {
      value: '',
      empty: '',
      emptyText: $t('d12f75264c'),
      suggesText: `${$t('0cd025fa')}，${$t('12822ccb')}！`,
      data: [],
      homeFinish: false,
      homeId: '',
      show: true,
      showCollect: true,
      loading: false,
      isHistory: false,
      handleScroll: () => {},
      top: 0,
      selectGroup: 0,
      groups: [],
      suggest: true
    }
  },
  provide() {
    return {
      group: () => this.groups[this.selectGroup]?.id || 0,
    }
  },
  components: {
    imgList,
    search,
    groupSwiper
  },
  watch: {
    data(newValue, oldValue) {
      if (newValue.length == 0) {
        this.empty = 'm-data'
        this.emptyText = $t('d12f75264c')
      }
    }
    // value(newValue, oldValue) {
    //   this.show = false;
    //   this.homeId = '';
    //   this.homeFinish = false;
    //   this.$nextTick(() => {
    //     this.show = true;
    //     this.getData();
    //   });
    // },
  },

  beforeRouteEnter(to, from, next) {
    document.title = $t('6ab5f11fbd')
    if (from.path == '/detail') {
      next(vm => {
        vm.$nextTick(() => {
          vm.$refs.scroll.scrollTop = vm.top
          vm.getGroup()
        })
      })
    } else {
      next(vm => {
        vm.$Talog({
          id: 'iFinD_appStore_tssj_mobile',
          platform: window.platform
        })
        vm.data = []
        vm.show = false
        vm.value = decodeURIComponent(vm.$route.query.value)
        vm.selectGroup= +decodeURIComponent(vm.$route.query.type) || ''
        if (vm.value) {
          vm.showCollect = false
        } else {
          vm.showCollect = true
        }
        vm.homeId = ''
        vm.homeFinish = false
        vm.$nextTick(() => {
          vm.show = true
          vm.getGroup()
        })
      })
    }
  },
  // beforeRouteLeave(to, from, next) {
  //   if (to.path == '/search') {
  //     this.$nextTick(() => {
  //       this.$refs.ainput.focus();
  //     }, 500);
  //   }
  //   next(vm => {
  //     vm.show = false;
  //     vm.data = [];
  //   });
  // },
  computed: {
    isFullScreen() {
      const testUA = str => window.navigator.userAgent.indexOf(str) > -1
      console.log(testUA('iPhone'))
      return window && testUA('iPhone') && window.screen.height >= 812 && window.devicePixelRatio >= 2
    }
  },
  methods: {
    scroll(e) {
      const {scrollTop, clientHeight, scrollHeight} = e.target
      if (scrollHeight - scrollTop - clientHeight < 300) {
        this.getData()
      }
    },
    scroll2(e) {
      const {scrollTop, clientHeight, scrollHeight} = e.target
      this.top = scrollTop > 0 ? scrollTop : this.top
    },
    cancel() {
      this.showCollect = true
      this.data = []
      this.show = false
      this.homeId = ''
      this.homeFinish = false
      this.$nextTick(() => {
        this.show = true
        this.getData()
      })
    },
    showModal(){
      window.location.href = "client://client.html?action=ymtz^webid=2804^mode=new^url=https://vote.10jqka.com.cn/webvote/b865002924ea500a1ebb7e2b2db9e356"
    },
    jumpSearch() {
      // this.$router.push(`/search?value=${this.value}`)
      window.location.href = "client://client.html?action=ymtz^webid=2804^mode=new^url="+ location.origin + location.pathname + `/search?value=${this.value}`
    },
    getData() {
      if (this.homeFinish) {
        return
      }
      this.loading = true
      let group = this.groups[this.selectGroup]
      getList({
        id: this.homeId,
        pageSize: 10,
        content: this.value,
        needCollect: 0,
        tagType: group?.id
      })
        .then(res => {
          if (res && res.code === 1) {
            let {data} = res
            if (data) {
              if (data.length == 0) {
                this.homeFinish = true
                return
              }
              this.data = uniqueArr(this.data.concat(data))
              this.empty = ''
              this.homeId = data[data.length - 1].id
            } else {
              this.data = []
            }
          } else {
            this.empty = 'm-error'
            this.emptyText = $t('866b795eae')
          }
        })
        .catch(error => {
          this.empty = 'm-error'
          this.emptyText = $t('866b795eae')
        })
    },
    async getGroup() {
      let res = await getTypeList().catch(error => {
        this.empty = 'error'
        this.emptyText = $t('866b795eae')
      })
      if (res && res.code === 1) {
        this.groups = res.data
        this.groups.unshift({
          id: '',
          isHot: 0,
          name: $t('8818d4830d')
        })
        // this.selectGroup = res.data[0].id
        this.getData()
      }
    }
  },
  created() {
    this.handleScroll = throttle(this.scroll, 500)
  },
  mounted() {
    if(window.callNativeHandler){
      window.callNativeHandler("notifyWebHandleEvent", {
          method: "showFirstPageQuickAddDialog",
          params: {
              addAppId: "460"
          }
      }, function() {})
    }
     
    this.$Bus.$on('m-loadMore', () => {
      this.getData()
    })
    this.$Bus.$on('changeGroup', (index,id) => {
      this.$Talog({
        id: `iFinD_news_tssj_tab.click.${id}`,
      });
      setTimeout(() => {
        this.$Talog({
          id: `iFinD_appStore_tssj_tab.click.${id}`,
          img_id: id,
        });
      }, 500);

      this.selectGroup = index
      this.cancel()
    })
    this.$Bus.$on('m-search', (val, isHistory) => {
      this.value = val
      this.show = false
      this.data = []
      this.homeId = ''
      this.isHistory = true
      if (!val) {
        this.isHistory = false
      }
      this.homeFinish = false
      this.$nextTick(() => {
        this.show = true
        this.getData()
      })
    })
    const scrollview = this.$refs['scroll']
    // 移除监听
    scrollview.addEventListener('scroll', this.scroll2, true)
  },
  beforeDestroy() {
    // 获取指定元素
    const scrollview = this.$refs['scroll']
    // 移除监听
    scrollview.removeEventListener('scroll', this.scroll2, true)
  }
}
</script>
<style lang="less" scoped>
/deep/ .search {
  height: 36px;
  background: #f7f7f7;
  border-radius: 4px;
  flex: 1;
  margin-right: 16px;
  .search-logo {
    width: 20px;
    height: 20px;
    background: url('~@/assets/images/search.svg') no-repeat 100% 100%;
    display: inline-block;
  }
  .ant-input {
    height: 36px;
    padding-left: 32px !important;
    background: #f7f7f7;
    border-radius: 4px;
    border: none;
  }
}
.mobile {
  height: 101%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  position: static;
}
.page-footer {
  position: relative;
  background-color: #f5f5f5;
  &::before {
    content: '';
    position: absolute;
    width: 40px;
    height: 1px;
    top: 21px;
    left: 50%;
    background-color: #ccc;
    transform: translateX(-80px);
  }
  &::after {
    content: '';
    position: absolute;
    width: 40px;
    height: 1px;
    top: 21px;
    left: 50%;
    background-color: #ccc;
    transform: translateX(36px);
  }
}
.group-wrapper {
  width: 100%;
  position: fixed;
  top: 60px;
  padding: 0 12px;
  background: #fff;
  z-index: 9;
  .s-suggest {
    width: 100%;
    height: 30px;
    background: rgba(0,0,0,0.04);
    border-radius: 4px;
    display: flex;
    align-items: center;
    position: relative;
    padding: 0 8px;
    margin-bottom: 12px;
    .sound {
      width: 16px;
      height: 16px;
      background: url(~@/assets/images/sound.svg);
      background-size: 100% 100%;
      display: inline-block;
      margin-right: 4px;
    }
    .text {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #4691EE;
      letter-spacing: 0;
      font-weight: 400;
    }
    .close {
      width: 16px;
      height: 16px;
      background: url(~@/assets/images/s_close.svg);
      background-size: 100% 100%;
      display: inline-block;
      position: absolute;
      right: 8px;
    }
  }
}
</style>
